import React, { useEffect, useRef } from "react";
import IdCheckIo from "idcheckio-sdk";
import { config } from "../config/environment";

interface IdCheckScreenProps {
  onboardingUrl: string;
  exid: string;
  timestamp: string;
  onIdCheckComplete: (exid: string, timestamp: string) => void;
}

const IdCheckScreen: React.FC<IdCheckScreenProps> = ({
  onboardingUrl,
  exid,
  timestamp,
  onIdCheckComplete,
}) => {
  const idcheckRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const idcheck = new IdCheckIo({});

    idcheck.on("DOCUMENT_CAPTURED", () => {
      console.log("Document captured");
    });

    idcheck.on("ENDED", () => {
      console.log("IdCheck ended");
      onIdCheckComplete(exid, timestamp);
    });

    idcheck.on("ERROR", (error) => {
      console.log("ERROR", error);
      const redirectTimer = setTimeout(() => {
        window.location.href = config.REDIRECT_URL;
      }, 2000);

      return () => clearTimeout(redirectTimer);
    });

    if (onboardingUrl) {
      idcheck.init({
        url: onboardingUrl,
        element: "#idcheck-component",
      });
    }

    // Cleanup function
    return () => {
      // Cleanup IdCheck if needed
    };
  }, [onboardingUrl, exid, timestamp, onIdCheckComplete]);

  return (
    <>
      {onboardingUrl && (
        <div className="idcheck-screen">
          <div
            id="idcheck-component"
            ref={idcheckRef}
            className="full-size"
          ></div>
        </div>
      )}
    </>
  );
};

export default IdCheckScreen;
